import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Helper_Class } from '../../helper_class';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Http, Headers } from '@angular/http';
import { encrypt_decript } from '../../../assets/js/Encription_Decription';
import { Date_Formate } from '../../../assets/js/common';
import { ipaddress } from '../../ipaddress' ;import { MenuViewService } from 'src/app/common-module/menu-view/menu-view.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FrontDesk_Helper } from 'src/app/FrontDesk_module/FrontDesk_Helper';

declare var $: any;

@Component({
  selector: 'app-consolidated-bills',
  templateUrl: './consolidated-bills.component.html',
  styleUrls: ['./consolidated-bills.component.scss']
})
export class ConsolidatedBillsComponent implements OnInit {
  @ViewChild('printlogowithname') printlogowithname: ElementRef;
  @ViewChild('printbanner') printbanner: ElementRef;
  @ViewChild('printnoheader') printnoheader: ElementRef;
  @ViewChild('printheader') printheader: ElementRef;

  public Filter_txt;
  public From_show: boolean = true;
  public To_show: boolean = true;
  public f_date;
  public t_date;
  public userinfo;
  public appoint_txt;
  public hptl_clinic_id;
  public appointment_list:any = [];
  public currentDate;
  public CurrentDatetime;
  public Appoint_Date;
  public bill_date;
  public Docidname;
  public hospital_name;
  public hospitalAddress;
  public Hospital_location: string;
  public hosp_location:string;
  public hosp_district:string;
  public hosp_state:string;
  public hosp_zip:string;
  public hosp_telephone:string;
  public bill_type;
  public docBills = [];
  public medBills = [];
  public diagBills = [];
  public DisplayBills = [];
  public final_amount = "0.00";
  public Advance_bill = "0.00";
  public total_advance = "0.00";
  public balance_show: boolean = true;
  public paid_bill = "0.00";
  public remaing_billbal = "0.00";
  public sendDoctor:any = [];
  public sendPharmacy:any = [];
  public sendDiagnosis:any = [];
  public pharma_id;
  public diag_centre_id;
  public tempPaid = "0.00";
  public totalBillAmount = "0.00";
  public totalPaidAmount = "0.00";
  public TotalBalance = "0.00";
  public selectedAllFlage: boolean = false;
  public patient_name;
  public amount_collected;
  public previous_balshow;
  public balance_data;
  public dog_reg_id;
  public total_collected;
  public billing_print_array:any = [];
  public insuranceFlag: boolean = false;
  public insuranceDec;
  public hospital_logo;
  public mediBillAmount = "0.00";
  public client_id;
  public sub_id;
  public rel_id;
  public tempparray;
  public saveFlag: boolean = true;
  public totalDiscount = "0.00";
  public totalBill = "0.00";
  public totalPaid = "0.00";
  public patientList = []
  public admissionDate = "";
  public admissionTime = "";
  public dischargeDate = "";
  public dischargeTime = "";
  public app_id;
  public inpid;
  public insurer;
  public insCardNo;
  public policyno;
  public CCNno;
  public round_off;
  public print_template;
  public headerstyle;
  public paytypreq;
  public docBillDetails:any=[];
  public medcalDetailsArray:any=[];
  public digDetailsArray:any=[];
  public printlogostyle;
  public bannerimage;
  editbuttondie: boolean = false;
  newbuttondie: boolean = false;
  deletebuttondie:boolean = false;
  viewbuttondie: boolean = false;
  printbuttondie: boolean = false;

  constructor(public sanitize:DomSanitizer,public doctorservice: MenuViewService, 
    public toastr: ToastrService, public http: Http, public router: Router, 
    public messageservice: MenuViewService) { }

  async ngOnInit() {
    this.userinfo = Helper_Class.getInfo();
    if(this.userinfo.user_type =="front-desk"){
      this.print_template= this.userinfo.bill_print_template;
      this.printlogostyle=Helper_Class.getInfo().bill_print_logo_style;
      this.hospital_logo = ipaddress.Ip_with_img_address + Helper_Class.getInfo().bill_print_logo;
    } else {
      this.print_template= this.userinfo.hospitals[0].bill_print_template;
      this.printlogostyle=Helper_Class.getInfo().hospitals[0].bill_print_logo_style;
      this.hospital_logo = ipaddress.Ip_with_img_address + Helper_Class.getInfo().hospitals[0].bill_print_logo;
    }
    
    this.headerstyle = this.sanitize.bypassSecurityTrustHtml(Helper_Class.getInfo().hospitals[0].bill_print_heading);
    if(this.headerstyle == undefined || this.headerstyle == 'undefined'){
      this.headerstyle="";
    }

    if(this.userinfo.hospitals[0].bill_pay_type_req =="1"){
      this.paytypreq=false;
    } else {
      this.paytypreq=true;
    }

    var hospitaldet = Helper_Class.getHospital();
    this.hptl_clinic_id = hospitaldet[0].hptl_clinic_id;
    //this.hospital_logo = ipaddress.Ip_with_img_address + Helper_Class.getInfo().hospitals[0].logo;
    
    // get the appointment list
    this.bill_type = "doctor";
    this.Filter_txt = "All";
    this.Filter_change();
    this.Get_current_date();
  }

  Filter_change() {
    if (this.Filter_txt == "All") {
      this.From_show = true;
      this.To_show = true;
    } else if (this.Filter_txt == "Date") {
      this.From_show = false;
      this.To_show = false;
    }
  }

  Get_current_date() {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp.toString() + 'adm/curdate',
      JSON.stringify({
        country: ipaddress.country_code.toString()
      }),
      { headers: headers })
      .subscribe(
        response => {
          var obj = response.json();
          if (obj.current_date != null) {
            this.CurrentDatetime = obj.current_date;
            var get_date = obj.current_date.split('-');
            this.Appoint_Date = get_date[2] + "-" + get_date[1] + "-" + get_date[0];
            this.currentDate = obj.current_date;
            this.bill_date = Date_Formate(obj.current_date);
            this.Appoint_Date = this.CurrentDatetime;
            this.f_date = obj.current_date;
            this.t_date = obj.current_date;
          }
        },
        error => {
          //this.toastr.error("Internet is too slow or no connection, try again");
        }
      )
      // if (FrontDesk_Helper.getmodules() != null) {
      //   for (var i = 0; i < FrontDesk_Helper.getmodules().length; i++) {
      //     if (FrontDesk_Helper.getmodules()[i].module_id == "21") {
      //       if (FrontDesk_Helper.getmodules()[i].edit == "1" ) {
      //         this.editbuttondie = true;
      //       }
      //       if (FrontDesk_Helper.getmodules()[i].create == "1"  ) {
      //         this.newbuttondie = true;
      //       }
      //       if (FrontDesk_Helper.getmodules()[i].delete == "1") {
      //         this.deletebuttondie = true;
      //       }
      //       if (FrontDesk_Helper.getmodules()[i].print == "1") {
      //         this.printbuttondie = true; 
      //       }
      //       if (FrontDesk_Helper.getmodules()[i].view == "1" ) {
      //         this.viewbuttondie = true;
      //       }
      //     }
      //   }
      // }
  }

  OnDateChangedfrom(e) {
    this.f_date = e;
  }

  OnDateChangedto(e) {
    this.t_date = e;
  }

  async filter_click() {
    this.Appointment_change(this.client_id, this.rel_id, this.sub_id, this.tempparray)
  }

  getAppointments(patientList) {
    this.appointment_list = [];
    this.patientList = [];
    if (patientList.target.value.toString() != null && patientList.target.value.toString().length > 2) {
      var headers = new Headers();
      var name = patientList.target.value.toUpperCase();
      var send_data = JSON.stringify({
        hptl_clinic_id: this.hptl_clinic_id,
        first_name: name
      });
      headers.append('Content-Type', 'application/json');
      this.http.post(ipaddress.getIp.toString() + 'bill/inpa', send_data,
        { headers: headers })
        .subscribe(
          response => {
            var obj = response.json();
            if (obj.appointment != null) {
              for (var i = 0; i < obj.appointment.length; i++) {
                obj.appointment[i].middle_name
                if (obj.appointment[i].middle_name != undefined) {
                  this.Docidname = obj.appointment[i].doc_app_id + " - " + encrypt_decript.Decript(obj.appointment[i].first_name) + " " + encrypt_decript.Decript(obj.appointment[i].middle_name) + " " + encrypt_decript.Decript(obj.appointment[i].last_name) + " (" + Date_Formate(obj.appointment[i].admitted_date) + ")";

                } else {
                  this.Docidname = obj.appointment[i].doc_app_id + " - " + encrypt_decript.Decript(obj.appointment[i].first_name) + " " + encrypt_decript.Decript(obj.appointment[i].last_name) + " (" + Date_Formate(obj.appointment[i].admitted_date) + ")";
                }

                var sessiondata = null;
                if (obj.appointment[i].session != undefined && obj.appointment[i].session != undefined && obj.appointment[i].session != null) {
                  sessiondata = encrypt_decript.Decript(obj.appointment[i].session);
                }
                var address;
                if (obj.appointment[i].address2 != undefined && obj.appointment[i].address1 != undefined) {
                  address = encrypt_decript.Decript(obj.appointment[i].address1) + ", " + encrypt_decript.Decript(obj.appointment[i].address2)
                } else if (obj.appointment[i].address1 != undefined) {
                  address = encrypt_decript.Decript(obj.appointment[i].address1);
                } else {
                  address = "";
                }
                var hospital;
                if (obj.hosp_address2 != undefined) {
                  hospital = obj.hosp_address1 + "," + obj.hosp_address2;

                } else {
                  hospital = obj.hosp_address1;
                }
                var inpatientId = obj.appointment[i].inp_hosp_id != undefined ? obj.appointment[i].inp_hosp_id : "-";
                var zipcode = obj.appointment[i].zipcode != undefined ? encrypt_decript.Decript(obj.appointment[i].zipcode) : "";
                this.hospital_name = obj.hosp_name != undefined ? obj.hosp_name : "";
                this.hospitalAddress = hospital;
                this.hosp_location=obj.hosp_location;
                this.hosp_district = obj.hosp_district;
                this.hosp_state = obj.hosp_state;
                this.hosp_zip = obj.hosp_zip;
                this.hosp_telephone = obj.hosp_telephone;
                this.Hospital_location = obj.hosp_location + ", " + obj.hosp_district + " - " + obj.hosp_state + " " + obj.hosp_country + "  " + obj.hosp_zip;

                this.appointment_list.push({
                  doc_app_id: obj.appointment[i].doc_app_id,
                  doc_reg_id: obj.appointment[i].doc_reg_id,
                  client_reg_id: obj.appointment[i].client_reg_id,
                  relation_id: obj.appointment[i].relation_id,
                  sub_rel_id: obj.appointment[i].sub_rel_id,
                  address: address,
                  location: obj.appointment[i].location,
                  district: obj.appointment[i].district,
                  state: obj.appointment[i].state,
                  country: obj.appointment[i].country,
                  first_name: obj.appointment[i].first_name,
                  middle_name: obj.appointment[i].middle_name,
                  last_name: obj.appointment[i].last_name,
                  hptl_clinic_id: obj.appointment[i].hptl_clinic_id,
                  session: sessiondata,
                  city: obj.appointment[i].district,
                  zipcode: zipcode,
                  docid_name: this.Docidname,
                  advance: obj.appointment[i].advance,
                  balance: obj.appointment[i].balance,
                  inpatientId: inpatientId,
                  cgst: "12%",
                  sgst: "12$",
                  admitted_date: obj.appointment[i].admitted_date,
                  admitted_time: obj.appointment[i].admitted_time,
                  discharge_date: obj.appointment[i].discharge_date,
                  discharge_time: obj.appointment[i].discharge_time,
                  inpid: obj.appointment[i].inp_hosp_id,
                  insurer: obj.appointment[i].insurer,
                  insCardNo: obj.appointment[i].ins_card_no,
                  policyNo: obj.appointment[i].policy_no,
                  CNNno: obj.appointment[i].ins_ccn_no,
                });
              }
            }
          },
          error => {
            this.toastr.error("Network error, try again");
          }
        )
    }
  }

  Appointment_change(client_id, rel_id, Sub_id, patientDetails) {
    // this.CurrentDatetime = billdate;
    this.billing_print_array=[];
    this.client_id = client_id;
    this.sub_id = Sub_id;
    this.rel_id = rel_id;
    this.tempparray = patientDetails;
    this.app_id = this.tempparray.doc_app_id;
    this.inpid = patientDetails.inpatientId;
    this.insurer = patientDetails.insurer;
    this.insCardNo = patientDetails.insCardNo;
    this.policyno = patientDetails.policyNo;
    this.CCNno = patientDetails.CNNno;

    var headers = new Headers();
    var send_data;
    if (this.Filter_txt == "Date") {
      send_data = JSON.stringify({
        client_reg_id: client_id,
        relation_id: rel_id,
        sub_rel_id: Sub_id,
        app_id: this.tempparray.doc_app_id,
        from_date: this.f_date,
        to_date: this.t_date,
      });

    } else {
      send_data = JSON.stringify({
        client_reg_id: client_id,
        relation_id: rel_id,
        app_id: this.tempparray.doc_app_id,
        sub_rel_id: Sub_id,
      });
    }

    if (patientDetails.middle_name != undefined) {
      this.patient_name = encrypt_decript.Decript(patientDetails.first_name) + " " + encrypt_decript.Decript(patientDetails.middle_name) + " " + encrypt_decript.Decript(patientDetails.last_name);

    } else {
      if (patientDetails.last_name != undefined) {
        this.patient_name = encrypt_decript.Decript(patientDetails.first_name) + " " + encrypt_decript.Decript(patientDetails.last_name);
      } else {
        this.patient_name = encrypt_decript.Decript(patientDetails.first_name);
      }
    }

    if (patientDetails.balance != undefined) {
      this.amount_collected = true;
      this.balance_show = false;
      this.previous_balshow = false;
      this.balance_data = parseFloat(patientDetails.balance).toFixed();
      // this.final_amount = parseFloat(patientDetails.balance).toFixed();
      this.total_collected = parseFloat(patientDetails.balance).toFixed();
    }

    this.dog_reg_id = patientDetails.doc_reg_id;
    var zipcode = patientDetails.czipcode != undefined ? encrypt_decript.Decript(patientDetails.czipcode) : "";
    this.admissionDate = patientDetails.admitted_date != undefined ? Date_Formate(patientDetails.admitted_date) : "";
    if (patientDetails.admitted_date != undefined) {
      var admisTime = patientDetails.admitted_time.split(':');
      var h = admisTime[0], m = admisTime[1];
      this.admissionTime = (h > 12) ? (h - 12 + ':' + m + ' PM') : (h + ':' + m + ' AM');
    }
    this.dischargeDate = patientDetails.discharge_date != undefined ? Date_Formate(patientDetails.discharge_date) : "";
    if (patientDetails.discharge_time != undefined) {
      if(patientDetails.discharge_time !=":00"){
        var admisTime = patientDetails.discharge_time.split(':');
        var h = admisTime[0], m = admisTime[1];
        this.dischargeTime = (h > 12) ? (h - 12 + ':' + m + ' PM') : (h + ':' + m + ' AM');
      }
    }
    this.billing_print_array.push({
      dr_name: "Dr." + patientDetails.docid_name,
      licence_code: "",
      hptl_name: "",
      created_date: "",
      address: patientDetails.address,
      location: patientDetails.location + ", ",
      city: patientDetails.city + " - " + patientDetails.zipcode + ",",
      state: patientDetails.state + " - " + patientDetails.country + ",",
      telephone: patientDetails.telephone,
      inpatientId: patientDetails.inpatientId,
      appointment_id: patientDetails.doc_app_id,
      client_name: this.patient_name,

      caddress: "",
      clocation: patientDetails.clocation + ", ",
      clientcity: patientDetails.ccity + " - " + zipcode + ",",
      clestare: patientDetails.cstate + " - " + patientDetails.ccountry + ".",
      client_reg_id: patientDetails.client_reg_id,
      advance: patientDetails.advance,
      balance: patientDetails.balance,
    });
    this.docBills = [];
    this.medBills = [];
    this.diagBills = [];
    this.DisplayBills = [];
    this.sendDoctor = [];
    this.sendPharmacy = [];
    this.sendDiagnosis = [];
    this.totalBillAmount = "0.00";
    this.totalPaidAmount = "0.00";
    this.TotalBalance = "0.00";
    this.final_amount = "0.00";
    this.totalDiscount = "0.00";
    this.totalPaid = "0.00";
    this.totalBill = "0.00";

    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp.toString() + 'bill/gbfcp', send_data,

      { headers: headers })
      .subscribe(
        response => {
          var obj = response.json();
          if (obj != null) {
            console.log("BILL DETAILS ((())) "+JSON.stringify(obj))
            this.Advance_bill = obj.balance != undefined ? parseFloat(obj.balance).toFixed(2) : "0.00";
            this.total_advance = obj.advance != undefined ? parseFloat(obj.advance).toFixed(2) : "0.00";
            this.insuranceFlag = obj.pay_type_desc != undefined ? true : false;
            this.insuranceDec = obj.pay_type_desc != undefined ? obj.pay_type_desc : " ";
            var doctorBills = obj.doc_bills;
            // for doctor bill
            if (doctorBills != undefined) {
              for (var j = 0; j < doctorBills.length; j++) {
                var billList = doctorBills[j].bill_details;

                var billDetails = [];
                if (billList.length != 0) {
                  for (var i = 0; i < billList.length; i++) {
                    billDetails.push({
                      name: billList[i].name,
                      quantity: billList[i].quantity,
                      amount: billList[i].fee_before_concession,
                      fee: billList[i].fee,
                      concession: billList[i].concession
                    })
                  }
                }
                var bill_amount = doctorBills[j].bill_amount != undefined ? encrypt_decript.Decript(doctorBills[j].bill_amount) : "0.00";
                var bill_date = doctorBills[j].bill_date != undefined ? Date_Formate(doctorBills[j].bill_date) : "";
                var paid;
                paid = doctorBills[j].balance == "0.00" ? bill_amount : (parseFloat(bill_amount) - parseFloat(doctorBills[j].balance) - parseFloat(doctorBills[j].discount)).toFixed(2);
                this.totalBillAmount = (parseFloat(this.totalBillAmount) + parseFloat(bill_amount)).toFixed(2);
                this.totalPaidAmount = (parseFloat(this.totalPaidAmount) + parseFloat(paid)).toFixed(2);
                this.TotalBalance = (parseFloat(this.TotalBalance) + parseFloat(doctorBills[j].balance)).toFixed(2);
                var discount = doctorBills[j].discount != undefined ? doctorBills[j].discount : "0.00";
                var advance = doctorBills[j].advance != undefined ? parseFloat(doctorBills[j].advance).toFixed(2) : "0.00";
                var tempDoc = {
                  billing_id: doctorBills[j].billing_id,
                  bill_amount: bill_amount,
                  advance: advance,
                  balance: doctorBills[j].balance,
                  bill_date: bill_date,
                  paid_amount: paid,
                  discount: discount,
                  fin_year:doctorBills[j].fin_year,
                  checked: false,
                  type: "doctor",
                  billsList: billDetails,
                }
                this.docBills.push(tempDoc);
          
                if (doctorBills[j].balance == "0.00" || doctorBills[j].balance == "0") {
                  this.isAllSelected(tempDoc);
                }
              }
            }

            // for Pharma bill
            var pharmaBills = obj.pharma_bills;
            if (pharmaBills != undefined) {
              for (var j = 0; j < pharmaBills.length; j++) {
                var billList = pharmaBills[j].bill_details;
                var billDetails = [];
                this.pharma_id = pharmaBills[j].pharma_id;
                var tempPharma = {};
                if (billList.length != 0) {
                  for (var i = 0; i < billList.length; i++) {
                    var concession = billList[i].concession != undefined ? billList[i].concession : "0.00";
                    billDetails.push({
                      name: billList[i].type + "-" + billList[i].name,
                      batch_no: billList[i].batch_no,
                      quantity: billList[i].quantity,
                      amount: billList[i].amount,
                      concession: concession
                    })
                  }
                }
                var bill_amount = pharmaBills[j].bill_amount != undefined ? pharmaBills[j].bill_amount : " ";
                var bill_date = pharmaBills[j].bill_date != undefined ? Date_Formate(pharmaBills[j].bill_date) : "";
                var paid = pharmaBills[j].paid_amount != undefined ? pharmaBills[j].paid_amount : "0.00";
                this.totalBillAmount = (parseFloat(this.totalBillAmount) + parseFloat(bill_amount)).toFixed(2);
                this.totalPaidAmount = (parseFloat(this.totalPaidAmount) + parseFloat(paid)).toFixed(2);
                this.TotalBalance = (parseFloat(this.TotalBalance) + parseFloat(pharmaBills[j].balance)).toFixed(2);
                var discount = pharmaBills[j].discount != undefined ? pharmaBills[j].discount : "0.00";
                tempPharma = {
                  billing_id: pharmaBills[j].billing_id,
                  bill_amount: bill_amount,
                  balance: pharmaBills[j].balance,
                  bill_date: bill_date,
                  paid_amount: paid,
                  checked: false,
                  type: "pharma",
                  billsList: billDetails,
                  discount: discount,
                  fin_year:pharmaBills[j].fin_year,
                  pharma_id: pharmaBills[j].pharma_id
                }
                this.medBills.push(tempPharma);
                if (pharmaBills[j].balance == "0.00") {
                  this.isAllSelected(tempPharma);
                }
              }
            }

            // for Diagnosis bill
            var diagBills = obj.diag_bills;
            if (diagBills != undefined) {
              var diaPharma = {};
              for (var j = 0; j < diagBills.length; j++) {
                var billList = diagBills[j].bill_details;
                this.diag_centre_id = diagBills[j].diag_centre_id;
                var billDetails = [];
                if (billList.length != 0) {
                  for (var i = 0; i < billList.length; i++) {
                    var totalAmount = (parseFloat(billList[i].fee) / billList[i].quantity);
                    billDetails.push({
                      name: billList[i].name,
                      amount: totalAmount,
                      quantity: billList[i].quantity,
                      fee: billList[i].fee,
                      concession: billList[i].concession
                    })
                  }
                }
                var bill_amount = diagBills[j].bill_amount != undefined ? encrypt_decript.Decript(diagBills[j].bill_amount) : " ";
                var paid = diagBills[j].paid_amount != undefined ? diagBills[j].paid_amount : "0.00";
                var bill_date = diagBills[j].bill_date != undefined ? Date_Formate(diagBills[j].bill_date) : "";
                this.totalBillAmount = (parseFloat(this.totalBillAmount) + parseFloat(bill_amount)).toFixed(2);
                this.totalPaidAmount = (parseFloat(this.totalPaidAmount) + parseFloat(paid)).toFixed(2);
                this.TotalBalance = (parseFloat(this.TotalBalance) + parseFloat(diagBills[j].balance)).toFixed(2);
                diaPharma = {
                  billing_id: diagBills[j].billing_id,
                  bill_amount: bill_amount,
                  // advance : diagBills[j].advance,
                  balance: diagBills[j].balance,
                  bill_date: bill_date,
                  paid_amount: paid,
                  checked: false,
                  type: "diagnosis",
                  discount: diagBills[j].discount,
                  fin_year:diagBills[j].fin_year,
                  billsList: billDetails
                }
                this.diagBills.push(diaPharma);
                if (diagBills[j].balance == "0.00") {
                  this.isAllSelected(diaPharma);
                }
              }
            }
            this.billType('doctor');
          }
        },
        error => {
          this.toastr.error("Network error, try again later");
        }
      )
  }

  billType(billType) {
    this.DisplayBills = [];
    $("#hospBillIMG").attr("src", "../../../assets/ui_icons/hospital_bill_non_selected_icon.png");
    $("#pharBillIMG").attr("src", "../../../assets/ui_icons/pharmacy_bill_non_selected_icon.png");
    $("#diagBillIMG").attr("src", "../../../assets/ui_icons/diagnosis_bill_non_selected_icon.png");
    this.selectedAllFlage = false;
    if (billType == "doctor") {
      this.DisplayBills = this.docBills;
      this.selectedAllFlage = this.docBills.length == this.sendDoctor.length ? true : false;
      this.bill_type = "doctor";
      $("#hospBillIMG").attr("src", "../../../assets/ui_icons/hospital_bill_selected_icon.png");
    } else if (billType == "pharma") {
      this.DisplayBills = this.medBills;
      this.selectedAllFlage = this.medBills.length == this.sendPharmacy.length ? true : false;
      this.bill_type = "pharma";
      $("#pharBillIMG").attr("src", "../../../assets/ui_icons/pharmacy_bill_selected_icon.png");
    } else {
      this.DisplayBills = this.diagBills;
      this.bill_type = "diagnosis";
      this.selectedAllFlage = this.diagBills.length == this.sendDiagnosis.length ? true : false;
      $("#diagBillIMG").attr("src", "../../../assets/ui_icons/diagnosis_bill_selected_icon.png");
    }
  }

  advance_change() {

  }

  paid_change() {

  }

  isAllSelected(bill) {
    var paid_flag;
    var paidAmount;
    var balance;
    var isexists = false;
    if (bill.type == "doctor") {  // send for doctor
      if (this.sendDoctor.length != 0) {
        var index: any = 0;
        for (var j = 0; j < this.sendDoctor.length; j++) {
          index = 1;
        }
        if (index == 1) {
          for (var i = 0; i < this.sendDoctor.length; i++) {
            if (this.sendDoctor[i].billing_id == bill.billing_id) {
              this.sendDoctor.splice(i, 1);
              this.final_amount = (parseFloat(this.final_amount) - parseFloat(bill.balance)).toFixed(2);
              this.totalDiscount = (parseFloat(this.totalDiscount) - parseFloat(bill.discount)).toFixed(2);
              this.totalBill = (parseFloat(this.totalBill) - parseFloat(bill.bill_amount)).toFixed(2);
              this.totalPaid = (parseFloat(this.totalPaid) - parseFloat(bill.paid_amount)).toFixed(2);
              isexists = true;
              break;
            }
          }
          for (var k = 0; k < this.docBills.length; k++) {
            if (this.docBills[k].billing_id == bill.billing_id) {
              this.docBills[k].checked = false;
              break;
            }
          }

          if(isexists == false){
            var flag;
            if (parseFloat(bill.balance) == 0.00) {
              flag = "Fully paid";
            } else if (parseFloat(bill.balance) == parseFloat(bill.bill_amount)) {
              flag = "un paid";
            } else {
              flag = "Partially paid"
            }
            this.sendDoctor.push({
              billing_id: bill.billing_id,
              hptl_clinic_id: this.hptl_clinic_id,
              paid_amount: bill.paid_amount,
              balance: bill.balance,
              temp_balance: bill.balance,
              paid_flag: flag,
              billDetails: bill.billsList,
              fin_year:bill.fin_year,
              advance: bill.advance != undefined ? bill.advance : "0.00"
            });
            this.final_amount = (parseFloat(this.final_amount) + parseFloat(bill.balance)).toFixed(2);
            this.totalDiscount = (parseFloat(this.totalDiscount) + parseFloat(bill.balance)).toFixed(2);
            this.totalBill = (parseFloat(this.totalBill) + parseFloat(bill.bill_amount)).toFixed(2);
            this.totalPaid = (parseFloat(this.totalPaid) + parseFloat(bill.paid_amount)).toFixed(2);
            for (var k = 0; k < this.docBills.length; k++) {
              if (this.docBills[k].billing_id == bill.billing_id) {
                this.docBills[k].checked = true;
                break;
              }
            }
          }

        } else {
          var flag;
          if (parseFloat(bill.balance) == 0.00) {
            flag = "Fully paid";
          } else if (parseFloat(bill.balance) == parseFloat(bill.bill_amount)) {
            flag = "un paid";
          } else {
            flag = "Partially paid"
          }
          this.sendDoctor.push({
            billing_id: bill.billing_id,
            hptl_clinic_id: this.hptl_clinic_id,
            paid_amount: bill.paid_amount,
            balance: bill.balance,
            temp_balance: bill.balance,
            paid_flag: flag,
            billDetails: bill.billsList,
            fin_year:bill.fin_year,
            advance: bill.advance != undefined ? bill.advance : "0.00"
          });
          this.final_amount = (parseFloat(this.final_amount) + parseFloat(bill.balance)).toFixed(2);
          this.totalDiscount = (parseFloat(this.totalDiscount) + parseFloat(bill.balance)).toFixed(2);
          this.totalBill = (parseFloat(this.totalBill) + parseFloat(bill.bill_amount)).toFixed(2);
          this.totalPaid = (parseFloat(this.totalPaid) + parseFloat(bill.paid_amount)).toFixed(2);
          for (var k = 0; k < this.docBills.length; k++) {
            if (this.docBills[k].billing_id == bill.billing_id) {
              this.docBills[k].checked = true;
              break;
            }
          }
        }
      } else {
        var flag;
        if (parseFloat(bill.balance) == 0.00) {
          flag = "Fully paid";
        } else if (parseFloat(bill.balance) == parseFloat(bill.bill_amount)) {
          flag = "un paid";
        } else {
          flag = "Partially paid"
        }
        this.sendDoctor.push({
          billing_id: bill.billing_id,
          hptl_clinic_id: this.hptl_clinic_id,
          paid_amount: bill.paid_amount,
          balance: bill.balance,
          paid_flag: flag,
          temp_balance: bill.balance,
          billDetails: bill.billsList,
          fin_year:bill.fin_year,
          advance: bill.advance != undefined ? bill.advance : "0.00"
        });
        this.final_amount = (parseFloat(this.final_amount) + parseFloat(bill.balance)).toFixed(2);
        this.totalDiscount = (parseFloat(this.totalDiscount) + parseFloat(bill.discount)).toFixed(2);
        this.totalBill = (parseFloat(this.totalBill) + parseFloat(bill.bill_amount)).toFixed(2);
        this.totalPaid = (parseFloat(this.totalPaid) + parseFloat(bill.paid_amount)).toFixed(2);
        for (var k = 0; k < this.docBills.length; k++) {
          if (this.docBills[k].billing_id == bill.billing_id) {
            this.docBills[k].checked = true;
            break;
          }
        }
      }
      
    } else if (bill.type == "pharma") {// send for pharmacy
      if (this.sendPharmacy.length != 0) {
        var index: any = 0;
        for (var j = 0; j < this.sendPharmacy.length; j++) {
          if (this.sendPharmacy[j].order_id == bill.billing_id) {
            index = 1;
          }
        }
        if (index == 1) {
          for (var i = 0; i < this.sendPharmacy.length; i++) {
            if (this.sendPharmacy[i].order_id == bill.billing_id) {
              if (this.sendPharmacy[i].temp_balance != "0.00") {
                this.sendPharmacy.splice(i, 1);
              }

              this.final_amount = (parseFloat(this.final_amount) - parseFloat(bill.balance)).toFixed(2);
              this.mediBillAmount = (parseFloat(this.mediBillAmount) - parseFloat(bill.bill_amount)).toFixed(2);
              this.totalDiscount = (parseFloat(this.totalDiscount) - parseFloat(bill.discount)).toFixed(2);
              this.totalBill = (parseFloat(this.totalBill) - parseFloat(bill.bill_amount)).toFixed(2);
              this.totalPaid = (parseFloat(this.totalPaid) - parseFloat(bill.paid_amount)).toFixed(2);
              break;
            }
          }
          for (var k = 0; k < this.medBills.length; k++) {
            if (this.medBills[k].billing_id == bill.billing_id) {
              if (this.medBills[k].balance == "0.00") {
                this.medBills[k].checked = true;
              } else {
                this.medBills[k].checked = false;
              }
              break;
            }
          }

        } else {
          var flag;
          if (parseFloat(bill.balance) == 0.00) {
            flag = "Fully paid";
          } else if (parseFloat(bill.balance) == parseFloat(bill.bill_amount)) {
            flag = "un paid";
          } else {
            flag = "Partially paid"
          }
          this.sendPharmacy.push({
            order_id: bill.billing_id,
            pharma_id: bill.pharma_id,
            paid_amount: bill.paid_amount,
            balance: bill.balance,
            temp_balance: bill.balance,
            paid_flag: flag,
            billDetails: bill.billsList,
            fin_year:bill.fin_year,
            advance: bill.advance != undefined ? bill.advance : "0.00"
          });
          this.final_amount = (parseFloat(this.final_amount) + parseFloat(bill.balance)).toFixed(2);
          this.mediBillAmount = (parseFloat(this.mediBillAmount) + parseFloat(bill.bill_amount)).toFixed(2);
          this.totalDiscount = (parseFloat(this.totalDiscount) + parseFloat(bill.discount)).toFixed(2);
          this.totalBill = (parseFloat(this.totalBill) + parseFloat(bill.bill_amount)).toFixed(2);
          this.totalPaid = (parseFloat(this.totalPaid) + parseFloat(bill.paid_amount)).toFixed(2);
          for (var k = 0; k < this.medBills.length; k++) {
            if (this.medBills[k].billing_id == bill.billing_id) {
              this.medBills[k].checked = true;
              break;
            }
          }
        }

      } else {
        var flag;
        if (parseFloat(bill.balance) == 0.00) {
          flag = "Fully paid";
        } else if (parseFloat(bill.balance) == parseFloat(bill.bill_amount)) {
          flag = "un paid";
        } else {
          flag = "Partially paid"
        }
        this.sendPharmacy.push({
          order_id: bill.billing_id,
          pharma_id: bill.pharma_id,
          paid_amount: bill.paid_amount,
          balance: bill.balance,
          paid_flag: flag,
          temp_balance: bill.balance,
          billDetails: bill.billsList,
          fin_year:bill.fin_year,
          advance: bill.advance != undefined ? bill.advance : "0.00"
        });
        this.final_amount = (parseFloat(this.final_amount) + parseFloat(bill.balance)).toFixed(2);
        this.mediBillAmount = (parseFloat(this.mediBillAmount) + parseFloat(bill.bill_amount)).toFixed(2);
        this.totalDiscount = (parseFloat(this.totalDiscount) + parseFloat(bill.discount)).toFixed(2);
        this.totalBill = (parseFloat(this.totalBill) + parseFloat(bill.bill_amount)).toFixed(2);
        this.totalPaid = (parseFloat(this.totalPaid) + parseFloat(bill.paid_amount)).toFixed(2);
        for (var k = 0; k < this.medBills.length; k++) {
          if (this.medBills[k].billing_id == bill.billing_id) {
            this.medBills[k].checked = true;
            break;
          }
        }
      }

    } else { // send for diagnosis
      if (this.sendDiagnosis.length != 0) {
        var index: any = 0;
        for (var j = 0; j < this.sendDiagnosis.length; j++) {
          if (this.sendDiagnosis[j].billing_id == bill.billing_id) {
            index = 1;
          }
        }
        if (index == 1) {
          for (var i = 0; i < this.sendDiagnosis.length; i++) {
            if (this.sendDiagnosis[i].billing_id == bill.billing_id) {
              if (this.sendDiagnosis[i].temp_balance != "0.00") {
                this.sendDiagnosis.splice(i, 1);
              }
              this.final_amount = (parseFloat(this.final_amount) - parseFloat(bill.balance)).toFixed(2);
              this.totalBill = (parseFloat(this.totalBill) - parseFloat(bill.bill_amount)).toFixed(2);
              this.totalPaid = (parseFloat(this.totalPaid) - parseFloat(bill.paid_amount)).toFixed(2);
              break;
            }
          }
          for (var k = 0; k < this.diagBills.length; k++) {
            if (this.diagBills[k].billing_id == bill.billing_id) {
              if (this.diagBills[k].balance == "0.00") {
                this.diagBills[k].checked = true;
              } else {
                this.diagBills[k].checked = false;
              }
              break;
            }
          }
        } else {
          var flag;
          if (parseFloat(bill.balance) == 0.00) {
            flag = "Fully paid";
          } else if (parseFloat(bill.balance) == parseFloat(bill.bill_amount)) {
            flag = "un paid";
          } else {
            flag = "Partially paid"
          }
          this.sendDiagnosis.push({
            billing_id: bill.billing_id,
            diag_centre_id: this.diag_centre_id,
            paid_amount: bill.paid_amount,
            balance: bill.balance,
            paid_flag: flag,
            temp_balance: bill.balance,
            billDetails: bill.billsList,
            fin_year:bill.fin_year,
          });
          this.final_amount = (parseFloat(this.final_amount) + parseFloat(bill.balance)).toFixed(2);
          this.totalBill = (parseFloat(this.totalBill) + parseFloat(bill.bill_amount)).toFixed(2);
          this.totalPaid = (parseFloat(this.totalPaid) + parseFloat(bill.paid_amount)).toFixed(2);
          for (var k = 0; k < this.diagBills.length; k++) {
            if (this.diagBills[k].billing_id == bill.billing_id) {
              this.diagBills[k].checked = true;
              break;
            }
          }
        }
      } else {
        var flag;
        if (parseFloat(bill.balance) == 0.00) {
          flag = "Fully paid";
        } else if (parseFloat(bill.balance) == parseFloat(bill.bill_amount)) {
          flag = "un paid";
        } else {
          flag = "Partially paid"
        }
        this.sendDiagnosis.push({
          billing_id: bill.billing_id,
          diag_centre_id: this.diag_centre_id,
          paid_amount: bill.paid_amount,
          balance: bill.balance,
          paid_flag: flag,
          temp_balance: bill.balance,
          billDetails: bill.billsList,
          fin_year:bill.fin_year,
          advance: bill.advance != undefined ? bill.advance : "0.00"
        });
        this.final_amount = (parseFloat(this.final_amount) + parseFloat(bill.balance)).toFixed(2);
        this.totalBill = (parseFloat(this.totalBill) + parseFloat(bill.bill_amount)).toFixed(2);
        this.totalPaid = (parseFloat(this.totalPaid) + parseFloat(bill.paid_amount)).toFixed(2);
        for (var k = 0; k < this.diagBills.length; k++) {
          if (this.diagBills[k].billing_id == bill.billing_id) {
            this.diagBills[k].checked = true;
            break;
          }
        }
      }
    }
    if (this.sendDoctor.length != 0) {
      this.docBillDetails=[];
      for (var j = 0; j < this.sendDoctor.length; j++) {
        for (var k = 0; k < this.sendDoctor[j].billDetails.length; k++) {
          this.docBillDetails.push({
            name:this.sendDoctor[j].billDetails[k].name,
            quantity:this.sendDoctor[j].billDetails[k].quantity,
            amount:this.sendDoctor[j].billDetails[k].amount,
            concession:this.sendDoctor[j].billDetails[k].concession,
            fee:this.sendDoctor[j].billDetails[k].fee,
          })
        }
      }
    }

    if (this.sendPharmacy.length != 0) {
      this.medcalDetailsArray=[];
      if (this.insuranceFlag != false) {
        for (var x = 0; x < this.sendPharmacy.length; x++) {
          for (var y = 0; y < this.sendPharmacy[x].billDetails.length; y++) {
            this.medcalDetailsArray.push({
              name: this.sendPharmacy[x].billDetails[y].name,
              batch_no:this.sendPharmacy[x].billDetails[y].batch_no,
              quantity:this.sendPharmacy[x].billDetails[y].quantity,
              concession:this.sendPharmacy[x].billDetails[y].oncession,
              amount:this.sendPharmacy[x].billDetails[y].amount,
            })
          }
        }
      } else {
        for (var x = 0; x < this.sendPharmacy.length; x++) {
          for (var y = 0; y < this.sendPharmacy[x].billDetails.length; y++) {
            this.medcalDetailsArray.push({
              name: this.sendPharmacy[x].order_id,
              amount:parseFloat(this.sendPharmacy[x].temp_balance).toFixed(2),
            })
          }
        }
      }
    }

    if (this.sendDiagnosis.length != 0) {
      for (var x = 0; x < this.sendDiagnosis.length; x++) {
        for (var y = 0; y < this.sendDiagnosis[x].billDetails.length; y++) {
          this.digDetailsArray.push({
            name: this.sendDiagnosis[x].billDetails[j].name,
            amount: this.sendDiagnosis[x].billDetails[j].amount,
            quantity: this.sendDiagnosis[x].billDetails[j].quantity,
            fee: this.sendDiagnosis[x].billDetails[j].fee,
            concession: this.sendDiagnosis[x].billDetails[j].concession,
          })
        }
      }
    }

    this.remaing_billbal = (parseFloat(this.final_amount) - (parseFloat(this.Advance_bill) + parseFloat(this.paid_bill))).toFixed(2);
  }

  allSelected(value) {
    this.selectedAllFlage = value == true ? true : false;
    if (this.bill_type == "doctor") {
      if ((this.docBills.length != this.sendDoctor.length) || this.sendDoctor.length == 0) {
        this.sendDoctor = [];
        // this.final_amount = "0.00";
        for (var k = 0; k < this.docBills.length; k++) {
          // this.isAllSelected(this.docBills[k]);
          var flag;
          if (parseFloat(this.docBills[k].balance) == 0.00) {
            flag = "Fully paid";
          } else if (parseFloat(this.docBills[k].balance) == parseFloat(this.docBills[k].bill_amount)) {
            flag = "un paid";
          } else {
            flag = "Partially paid"
          }
          this.sendDoctor.push({
            billing_id: this.docBills[k].billing_id,
            hptl_clinic_id: this.hptl_clinic_id,
            paid_amount: this.docBills[k].paid_amount,
            balance: this.docBills[k].balance,
            paid_flag: flag,
            advance: this.docBills[k].advance,
            temp_balance: this.docBills[k].balance,
            fin_year:this.docBills[k].fin_year,
            billDetails: this.docBills[k].billsList,
          });
          this.docBills[k].checked = true;
          this.final_amount = (parseFloat(this.final_amount) + parseFloat(this.docBills[k].balance)).toFixed(2);
          this.totalDiscount = (parseFloat(this.totalDiscount) + parseFloat(this.docBills[k].discount)).toFixed(2);
          this.totalBill = (parseFloat(this.totalBill) + parseFloat(this.docBills[k].bill_amount)).toFixed(2);
          this.totalPaid = (parseFloat(this.totalPaid) + parseFloat(this.docBills[k].paid_amount)).toFixed(2);
        }
      } else {
        this.sendDoctor = [];
        for (var k = 0; k < this.docBills.length; k++) {
          this.docBills[k].checked = false;
          this.final_amount = (parseFloat(this.final_amount) - parseFloat(this.docBills[k].balance)).toFixed(2);
          this.totalDiscount = (parseFloat(this.totalDiscount) - parseFloat(this.docBills[k].discount)).toFixed(2);
          this.totalBill = (parseFloat(this.totalBill) - parseFloat(this.docBills[k].bill_amount)).toFixed(2);
          this.totalPaid = (parseFloat(this.totalPaid) - parseFloat(this.docBills[k].paid_amount)).toFixed(2);
        }
      }

    } else if (this.bill_type == "pharma") {
      if ((this.medBills.length != this.sendPharmacy.length) || this.sendPharmacy.length == 0) {
        this.sendPharmacy = [];
        // this.final_amount = "0.00";
        for (var k = 0; k < this.medBills.length; k++) {
          // this.isAllSelected(this.medBills[k]);
          var flag;
          if (parseFloat(this.medBills[k].balance) == 0.00) {
            flag = "Fully paid";
          } else if (parseFloat(this.medBills[k].balance) == parseFloat(this.medBills[k].bill_amount)) {
            flag = "un paid";
          } else {
            flag = "Partially paid"
          }
          this.sendPharmacy.push({
            order_id: this.medBills[k].billing_id,
            pharma_id: this.medBills[k].pharma_id,
            paid_amount: this.medBills[k].paid_amount,
            balance: this.medBills[k].balance,
            paid_flag: flag,
            temp_balance: this.medBills[k].balance,
            fin_year:this.medBills[k].fin_year,
            billDetails: this.medBills[k].billsList,
            advance: this.medBills[k].advance != undefined ? this.medBills[k].advance : "0.00"
          });
          this.medBills[k].checked = true;
          this.final_amount = (parseFloat(this.final_amount) + parseFloat(this.medBills[k].balance)).toFixed(2);
          this.mediBillAmount = (parseFloat(this.mediBillAmount) + parseFloat(this.medBills[k].bill_amount)).toFixed(2);
          this.totalDiscount = (parseFloat(this.totalDiscount) + parseFloat(this.medBills[k].discount)).toFixed(2);
          this.totalBill = (parseFloat(this.totalBill) + parseFloat(this.medBills[k].bill_amount)).toFixed(2);
          this.totalPaid = (parseFloat(this.totalPaid) + parseFloat(this.medBills[k].paid_amount)).toFixed(2);
        }

      } else {
        //this.sendPharmacy = [];
        for (var i = 0; i < this.sendPharmacy.length; i++) {
          if (this.sendPharmacy[i].temp_balance != "0.00") {
            this.sendPharmacy.splice(i, 1);
          }
        }
        for (var k = 0; k < this.medBills.length; k++) {
          if (this.medBills[k].balance == "0.00") {
            this.medBills[k].checked = true;
          } else {
            this.medBills[k].checked = false;
          }
          this.final_amount = (parseFloat(this.final_amount) - parseFloat(this.medBills[k].balance)).toFixed(2);
          this.mediBillAmount = (parseFloat(this.mediBillAmount) - parseFloat(this.medBills[k].bill_amount)).toFixed(2);
          this.totalDiscount = (parseFloat(this.totalDiscount) - parseFloat(this.medBills[k].discount)).toFixed(2);
          this.totalBill = (parseFloat(this.totalBill) - parseFloat(this.medBills[k].bill_amount)).toFixed(2);
          this.totalPaid = (parseFloat(this.totalPaid) - parseFloat(this.medBills[k].paid_amount)).toFixed(2);
        }
      }

    } else {
      if ((this.diagBills.length != this.sendDiagnosis.length) || this.sendDiagnosis.length == 0) {
        this.sendDiagnosis = [];
        for (var k = 0; k < this.diagBills.length; k++) {
          var flag;
          if (parseFloat(this.diagBills[k].balance) == 0.00) {
            flag = "Fully paid";
          } else if (parseFloat(this.diagBills[k].balance) == parseFloat(this.diagBills[k].bill_amount)) {
            flag = "un paid";
          } else {
            flag = "Partially paid"
          }
          this.sendDiagnosis.push({
            billing_id: this.diagBills[k].billing_id,
            diag_centre_id: this.diag_centre_id,
            paid_amount: this.diagBills[k].paid_amount,
            balance: this.diagBills[k].balance,
            paid_flag: flag,
            temp_balance: this.diagBills[k].balance,
            fin_year:this.diagBills[k].fin_year,
            billDetails: this.diagBills[k].billsList,
            advance: this.diagBills[k].advance != undefined ? this.diagBills[k].advance : "0.00"
          });
          this.diagBills[k].checked = true;
          this.final_amount = (parseFloat(this.final_amount) + parseFloat(this.diagBills[k].balance)).toFixed(2);
          this.totalBill = (parseFloat(this.totalBill) + parseFloat(this.diagBills[k].bill_amount)).toFixed(2);
          this.totalPaid = (parseFloat(this.totalPaid) + parseFloat(this.diagBills[k].paid_amount)).toFixed(2);
        }

      } else {
        for (var i = 0; i < this.sendDiagnosis.length; i++) {
          if (this.sendDiagnosis[i].temp_balance != "0.00") {
            this.sendDiagnosis.splice(i, 1);
          }
        }
        for (var k = 0; k < this.diagBills.length; k++) {
          if (this.diagBills[k].balance == "0.00") {
            this.diagBills[k].checked = true;
          } else {
            this.diagBills[k].checked = false;
          }
          this.final_amount = (parseFloat(this.final_amount) - parseFloat(this.diagBills[k].balance)).toFixed(2);
          this.totalBill = (parseFloat(this.totalBill) - parseFloat(this.diagBills[k].bill_amount)).toFixed(2);
          this.totalPaid = (parseFloat(this.totalPaid) - parseFloat(this.diagBills[k].paid_amount)).toFixed(2);
        }
      }
    }

    if (this.sendDoctor.length != 0) {
      this.docBillDetails=[];
      for (var j = 0; j < this.sendDoctor.length; j++) {
        for (var k = 0; k < this.sendDoctor[j].billDetails.length; k++) {
          this.docBillDetails.push({
            name:this.sendDoctor[j].billDetails[k].name,
            quantity:this.sendDoctor[j].billDetails[k].quantity,
            amount:this.sendDoctor[j].billDetails[k].amount,
            concession:this.sendDoctor[j].billDetails[k].concession,
            fee:this.sendDoctor[j].billDetails[k].fee,
          })
        }
      }
    }

    if (this.sendPharmacy.length != 0) {
      this.medcalDetailsArray=[];
      if (this.insuranceFlag != false) {
        for (var x = 0; x < this.sendPharmacy.length; x++) {
          for (var y = 0; y < this.sendPharmacy[x].billDetails.length; y++) {
            this.medcalDetailsArray.push({
              name: this.sendPharmacy[x].billDetails[y].name,
              batch_no:this.sendPharmacy[x].billDetails[y].batch_no,
              quantity:this.sendPharmacy[x].billDetails[y].quantity,
              concession:this.sendPharmacy[x].billDetails[y].oncession,
              amount:this.sendPharmacy[x].billDetails[y].amount,
            })
          }
        }
      } else {
        for (var x = 0; x < this.sendPharmacy.length; x++) {
          for (var y = 0; y < this.sendPharmacy[x].billDetails.length; y++) {
            this.medcalDetailsArray.push({
              name: this.sendPharmacy[x].order_id,
              amount:parseFloat(this.sendPharmacy[x].temp_balance).toFixed(2),
            })
          }
        }
      }
    }

    if (this.sendDiagnosis.length != 0) {
      for (var x = 0; x < this.sendDiagnosis.length; x++) {
        for (var y = 0; y < this.sendDiagnosis[x].billDetails.length; y++) {
          this.digDetailsArray.push({
            name: this.sendDiagnosis[x].billDetails[j].name,
            amount: this.sendDiagnosis[x].billDetails[j].amount,
            quantity: this.sendDiagnosis[x].billDetails[j].quantity,
            fee: this.sendDiagnosis[x].billDetails[j].fee,
            concession: this.sendDiagnosis[x].billDetails[j].concession,
          })
        }
      }
    }

    this.remaing_billbal = (parseFloat(this.final_amount) - (parseFloat(this.Advance_bill) + parseFloat(this.paid_bill))).toFixed(2);
  }

  checkBalance() {
    if (this.paid_bill != "") {
      // if (parseFloat(this.paid_bill) >= parseFloat(this.final_amount)) {
      //   this.balance_show = false;
      //   this.remaing_billbal = (parseFloat(this.final_amount) - (parseFloat(this.paid_bill) + parseFloat(this.Advance_bill))).toFixed(2);
      // } else {
      this.balance_show = false;
      //  var paid_bal = (parseFloat(this.paid_bill) + parseFloat(this.Advance_bill)).toFixed(2);
      var advanceBalance = (parseFloat(this.Advance_bill)).toFixed(2);
      var paidBalance = (parseFloat(this.paid_bill)).toFixed(2);
      this.remaing_billbal = (parseFloat(this.final_amount) - (parseFloat(this.paid_bill) + parseFloat(this.Advance_bill))).toFixed(2);

      if (this.sendDoctor.length != 0) {
        for (var i = 0; i < this.sendDoctor.length; i++) {
          if (parseFloat(advanceBalance) != 0.00 || parseFloat(paidBalance) != 0.00) {
            if (parseFloat(advanceBalance) != 0.00) {
              if (parseFloat(this.sendDoctor[i].temp_balance) <= parseFloat(advanceBalance)) {
                this.sendDoctor[i].paid_amount = "0.00";
                this.sendDoctor[i].advance = (parseFloat(this.sendDoctor[i].temp_balance) + parseFloat(this.sendDoctor[i].advance)).toFixed(2);
                this.sendDoctor[i].balance = "0.00";
                this.sendDoctor[i].paid_flag = "Fully paid";
                advanceBalance = (parseFloat(advanceBalance) - parseFloat(this.sendDoctor[i].temp_balance)).toFixed(2);
              } else {
                var getRemindingAmount = (parseFloat(this.sendDoctor[i].temp_balance) - parseFloat(advanceBalance)).toFixed(2);
                if (parseFloat(getRemindingAmount) <= parseFloat(paidBalance)) {
                  this.sendDoctor[i].paid_amount = parseFloat(getRemindingAmount).toFixed(2);
                  this.sendDoctor[i].advance = (parseFloat(advanceBalance) + parseFloat(this.sendDoctor[i].advance)).toFixed(2);
                  this.sendDoctor[i].balance = "0.00";
                  this.sendDoctor[i].paid_flag = "Fully paid";
                  paidBalance = (parseFloat(paidBalance) - parseFloat(getRemindingAmount)).toFixed(2);
                } else {

                  var remaingBal = (parseFloat(this.sendDoctor[i].temp_balance) - (parseFloat(paidBalance) + parseFloat(advanceBalance))).toFixed(2);
                  this.sendDoctor[i].paid_amount = paidBalance;
                  this.sendDoctor[i].balance = remaingBal;
                  this.sendDoctor[i].advance = (parseFloat(advanceBalance) + parseFloat(this.sendDoctor[i].advance)).toFixed(2);
                  this.sendDoctor[i].paid_flag = "Partially paid";
                  paidBalance = "0.00";
                }
                advanceBalance = "0.00";
                break;
              }

            } else {
              if (parseFloat(this.sendDoctor[i].temp_balance) <= parseFloat(paidBalance)) {
                this.sendDoctor[i].paid_amount = this.sendDoctor[i].temp_balance;
                this.sendDoctor[i].advance = parseFloat(this.sendDoctor[i].advance).toFixed(2);
                this.sendDoctor[i].balance = "0.00";
                this.sendDoctor[i].paid_flag = "Fully paid";
                paidBalance = (parseFloat(paidBalance) - parseFloat(this.sendDoctor[i].temp_balance)).toFixed(2);

              } else {
                var remaingBal = (parseFloat(this.sendDoctor[i].temp_balance) - parseFloat(paidBalance)).toFixed(2);
                this.sendDoctor[i].paid_amount = paidBalance;
                this.sendDoctor[i].balance = remaingBal;
                this.sendDoctor[i].advance = parseFloat(this.sendDoctor[i].advance).toFixed(2);
                this.sendDoctor[i].paid_flag = "Partially paid";
                paidBalance = "0.00";
                break;
              }
            }
          }
        }
      }

      if (parseFloat(advanceBalance) != 0.00 || parseFloat(paidBalance) != 0.00) {
        if (this.sendPharmacy.length != 0) {
          for (var i = 0; i < this.sendPharmacy.length; i++) {
            if (parseFloat(advanceBalance) != 0.00) {
              if (parseFloat(this.sendPharmacy[i].temp_balance) <= parseFloat(advanceBalance)) {
                this.sendPharmacy[i].paid_amount = "0.00";
                this.sendPharmacy[i].advance = (parseFloat(this.sendPharmacy[i].temp_balance)).toFixed(2);
                this.sendPharmacy[i].balance = "0.00";
                this.sendPharmacy[i].paid_flag = "Fully paid";
                advanceBalance = (parseFloat(advanceBalance) - parseFloat(this.sendPharmacy[i].temp_balance)).toFixed(2);

              } else {
                var getRemindingAmount = (parseFloat(this.sendPharmacy[i].temp_balance) - parseFloat(advanceBalance)).toFixed(2);
                if (parseFloat(getRemindingAmount) <= parseFloat(paidBalance)) {
                  this.sendPharmacy[i].paid_amount = parseFloat(getRemindingAmount).toFixed(2);
                  this.sendPharmacy[i].advance = (parseFloat(advanceBalance)).toFixed(2);
                  this.sendPharmacy[i].balance = "0.00";
                  this.sendPharmacy[i].paid_flag = "Fully paid";
                  paidBalance = (parseFloat(paidBalance) - parseFloat(getRemindingAmount)).toFixed(2);

                } else {
                  var tempPaidBal = (parseFloat(getRemindingAmount) - parseFloat(paidBalance)).toFixed(2)
                  var remaingBal = (parseFloat(this.sendPharmacy[i].temp_balance) - (parseFloat(tempPaidBal) + parseFloat(advanceBalance))).toFixed(2);
                  this.sendPharmacy[i].paid_amount = parseFloat(paidBalance).toFixed(2);
                  this.sendPharmacy[i].balance = remaingBal;
                  this.sendPharmacy[i].advance = (parseFloat(advanceBalance)).toFixed(2);
                  this.sendPharmacy[i].paid_flag = "Partially paid";
                  paidBalance = "0.00";

                }
                advanceBalance = "0.00";
              }

            } else if (parseFloat(paidBalance) != 0.00) {
              if (parseFloat(this.sendPharmacy[i].temp_balance) <= parseFloat(paidBalance)) {
                this.sendPharmacy[i].paid_amount = this.sendPharmacy[i].temp_balance;
                this.sendPharmacy[i].advance = "0.00";
                this.sendPharmacy[i].balance = "0.00";
                this.sendPharmacy[i].paid_flag = "Fully paid";
                paidBalance = (parseFloat(paidBalance) - parseFloat(this.sendPharmacy[i].temp_balance)).toFixed(2);

              } else {
                var remaingBal = (parseFloat(this.sendPharmacy[i].temp_balance) - parseFloat(paidBalance)).toFixed(2);
                this.sendPharmacy[i].paid_amount = paidBalance;
                this.sendPharmacy[i].balance = remaingBal;
                this.sendPharmacy[i].advance = "0.00";
                this.sendPharmacy[i].paid_flag = "Partially paid";
                paidBalance = "0.00";
              }
              advanceBalance = "0.00";
            } else {
              break;
            }
          }
        }
      }

      if (parseFloat(advanceBalance) != 0.00 || parseFloat(paidBalance) != 0.00) {
        if (this.sendDiagnosis.length != 0) {
          for (var i = 0; i < this.sendDiagnosis.length; i++) {
            if (parseFloat(advanceBalance) != 0.00) {
              if (parseFloat(this.sendDiagnosis[i].temp_balance) <= parseFloat(advanceBalance)) {
                this.sendDiagnosis[i].paid_amount = "0.00";
                this.sendDiagnosis[i].advance = (parseFloat(this.sendDiagnosis[i].temp_balance)).toFixed(2);
                this.sendDiagnosis[i].balance = "0.00";
                this.sendDiagnosis[i].paid_flag = "Fully paid";
                advanceBalance = (parseFloat(advanceBalance) - parseFloat(this.sendDiagnosis[i].temp_balance)).toFixed(2);
              
              } else {
                var getRemindingAmount = (parseFloat(this.sendDiagnosis[i].temp_balance) - parseFloat(advanceBalance)).toFixed(2);
                if (parseFloat(getRemindingAmount) <= parseFloat(paidBalance)) {
                  this.sendDiagnosis[i].paid_amount = parseFloat(getRemindingAmount).toFixed(2);
                  this.sendDiagnosis[i].advance = (parseFloat(advanceBalance)).toFixed(2);
                  this.sendDiagnosis[i].balance = "0.00";
                  this.sendDiagnosis[i].paid_flag = "Fully paid";
                  paidBalance = (parseFloat(paidBalance) - parseFloat(getRemindingAmount)).toFixed(2);
                } else {
                  var tempPaidBal = (parseFloat(getRemindingAmount) - parseFloat(paidBalance)).toFixed(2)
                  var remaingBal = (parseFloat(this.sendDiagnosis[i].temp_balance) - (parseFloat(tempPaidBal) + parseFloat(advanceBalance))).toFixed(2);
                  this.sendDiagnosis[i].paid_amount = tempPaidBal;
                  this.sendDiagnosis[i].balance = remaingBal;
                  this.sendDiagnosis[i].advance = (parseFloat(advanceBalance)).toFixed(2);
                  this.sendDiagnosis[i].paid_flag = "Partially paid";
                  paidBalance = "0.00";
                }
                advanceBalance = "0.00";
              }

            } else if (parseFloat(paidBalance) != 0.00) {
              if (parseFloat(this.sendDiagnosis[i].temp_balance) <= parseFloat(paidBalance)) {
                this.sendDiagnosis[i].paid_amount = this.sendDiagnosis[i].temp_balance;
                this.sendDiagnosis[i].advance = "0.00";
                this.sendDiagnosis[i].balance = "0.00";
                this.sendDiagnosis[i].paid_flag = "Fully paid";
                paidBalance = (parseFloat(paidBalance) - parseFloat(this.sendDiagnosis[i].temp_balance)).toFixed(2);

              } else {
                var remaingBal = (parseFloat(this.sendDiagnosis[i].temp_balance) - parseFloat(paidBalance)).toFixed(2);
                this.sendDiagnosis[i].paid_amount = paidBalance;
                this.sendDiagnosis[i].balance = remaingBal;
                this.sendDiagnosis[i].advance = "0.00";
                this.sendDiagnosis[i].paid_flag = "Partially paid";
                paidBalance = "0.00";
              }
              advanceBalance = "0.00";
            } else {
              break;
            }
          }
        }
      };

    } else {
      this.paid_bill = "0.00";
    }
  }

  // print_area() {
  //   var flag = true;
  //   if (this.totalDiscount == undefined) {
  //     this.totalDiscount = "0.00";
  //   }
  //   if (this.sendPharmacy.length == 0 && this.sendDiagnosis.length == 0 && this.sendDoctor.length == 0) {
  //     this.toastr.error("Error in print bill");

  //   } else {
  //     let printContents, popupWin;

  //     for (var i = 0; i < this.billing_print_array.length; i++) {
  //       var printContt = '<div id="bill-print-section"><div class="bill_border">';
  //       var hospitalAddress = hospitalAddress != '' ? '<span>' + this.hospitalAddress + '</span>' : "";
  //       var telephone = this.billing_print_array[i].telephone != undefined ? '<span ><img src="../../../assets/img/phone.png" width="15px" height="15px" />' + this.billing_print_array[i].telephone + '.</span>' : "";
  //       //  <span> <img src="../../../assets/img/phone.png" width="15px" height="15px" /> ' + this.billing_print_array[i].telephone + ' </span>
  //       var patientAddress = this.billing_print_array[i].address != '' ? this.billing_print_array[i].address : "";
  //       var adminssionDate = "";
  //       if (this.admissionDate != '') {
  //         if (this.admissionTime != "") {
  //           adminssionDate = ' <span>Admission Date : ' + this.admissionDate + '</span> <br /> <span>Admission  Time : ' + this.admissionTime + '</span> <br />'
  //         } else {
  //           adminssionDate = ' <span>Admission Date : ' + this.admissionDate + '</span> <br />';
  //         }
  //       }

  //       var dischargeDate = "";
  //       if (this.dischargeDate != '') {
  //         if (this.dischargeTime != "") {
  //           dischargeDate = '<span>Discharge Date' + this.dischargeDate + '</span> <br /> <span>Discharge Time : ' + this.dischargeTime + '</span> <br />';
  //         } else {
  //           dischargeDate = '<span>Discharge Date' + this.dischargeDate + '</span> <br />';
  //         }
  //       }

  //       printContt += '<table class="report-container" style="width:100%;"> <thead class="report-header"> <tr> <th class="report-header-cell"> <div class="header-info"> <div> <table style="width: 100%;"> <tr> <td style="display: flex;justify-content: center;"> <div> <img alt="image" src="' + this.hospital_logo + '" width="100px" height="100px" style="vertical-align: middle;"> </div> <div style="position: relative;top: 20px;left: 10px;text-align: left;"> <span><b>' + this.hospital_name + '</b>,</span><br/> <span>' + hospitalAddress + '</span><br/> <span>' + this.Hospital_location + '</span><br/> <span>' + this.billing_print_array[i].state + '</span>' + telephone + '<br><span>' + this.inpid + '</span> <br> </div> </td> </tr> </table> </div> </div> </th> </tr> </thead> <tfoot class="report-footer"> <tr> <td class="report-footer-cell"> <div class="footer-info"> <table style="width:100%"> <tr> <td> <p style="font-size: 13px;width: 100%; text-align: center;"><b><i>This is digitally generated bill</i></b></p> <br /> </td> </tr> </table> </div> </td> </tr> </tfoot><tbody class="report-content"> <tr> <td class="report-content-cell"> <div class="main"> <div class="article"> <div style="width: 90%; margin: 0 auto;"> <h3 style="margin:10px 0 ;" class="heading">Patient details</h3> <table style="width: 100%;"> <tr> <td style="width: 60%; vertical-align: top;"> <div> <span><strong>Patient name : </strong>' + this.billing_print_array[i].client_name + '</span> <br /> <span><strong> Inpatient id : </strong>' + this.billing_print_array[i].inpatientId + '</span> <br /> <span><strong>Address : </strong></span> <span>' + patientAddress + '</span> <br /> <span> ' + this.billing_print_array[i].location + " " + this.billing_print_array[i].city + '</span> <br /> <span> ' + this.billing_print_array[i].state + '</span> <br /> </div> </td> <td style="width: 40%;vertical-align: top;"> <div> <span>Bill date : ' + this.bill_date + '<br />' + adminssionDate + dischargeDate + '</div> </td> </tr> </table> </div>';
  //       // doctor bill list
  //       var doctotContent = "";
  //       var docBillList = "";
  //       if (this.sendDoctor.length != 0) {
  //         for (var j = 0; j < this.sendDoctor.length; j++) {
  //           for (var k = 0; k < this.sendDoctor[j].billDetails.length; k++) {
  //             this.docBillDetails.push({
  //               bill_type:this.sendDoctor[j].billDetails[k].name,
  //               quantity:this.sendDoctor[j].billDetails[k].quantity,
  //               amount:this.sendDoctor[j].billDetails[k].amount,
  //               concession:this.sendDoctor[j].billDetails[k].concession,
  //               fee:this.sendDoctor[j].billDetails[k].fee,
  //             })
  //             var getBillList = this.sendDoctor[j].billDetails[k];
  //             getBillList.name
  //             docBillList += '<tr><td style=" text-align: left;border: 1px solid black;border-collapse: collapse;padding:5px 5px;" data-th="Type">' + getBillList.name + '</td><td style=" text-align: right; border: 1px solid black;border-collapse: collapse;" data-th="Fee">' + getBillList.quantity + '</td><td style="text-align: right; border: 1px solid black;border-collapse: collapse;" data-th="Fee">' + getBillList.amount + '</td><td style="text-align: right; border: 1px solid black;border-collapse: collapse;" data-th="Concession">' + getBillList.concession + '</td><td style="text-align: right; border: 1px solid black;border-collapse: collapse;" data-th="Amount" class="fee_txt">' + getBillList.fee + '</td></tr>';
  //           }
  //         }
  //       }
  //       doctotContent += this.sendDoctor.length != 0 ? '<div style="width: 90%; margin: 0 auto;"> <h3 class="heading">Service Charges</h3> <div class="row"> <table style=" border: 1px solid black;border-collapse: collapse;margin-right: 20px;width:100%;"> <thead> <tr> <th style="width: 30%;border: 1px solid black;border-collapse: collapse;"> <b>Service</b> </th>  <th style="width: 15%;border: 1px solid black;border-collapse: collapse;"> <b>Quantity</b> </th> <th style="width: 15%;border: 1px solid black;border-collapse: collapse;"> <b>Fee</b> </th> <th style="width: 15%;border: 1px solid black;border-collapse: collapse;"> <b>Concession (%)</b> </th> <th style="width: 15%;border: 1px solid black;border-collapse: collapse;"> <b>Amount</b> </th> </tr> </thead> <tbody>' + docBillList + '</tbody> </table> </div> </div>' : " ";
  //       printContt += doctotContent;
  //       // dignosis bill list
  //       var diagContent = "";
  //       var diagList = "";
  //       if (this.sendDiagnosis.length != 0) {
  //         for (var x = 0; x < this.sendDiagnosis.length; x++) {
  //           for (var y = 0; y < this.sendDiagnosis[x].billDetails.length; y++) {
  //             var getDiagList = this.sendDiagnosis[x].billDetails[y];
  //             diagList += '<tr><td style=" text-align: left;border: 1px solid black;border-collapse: collapse;padding:5px 5px;" data-th="Type">' + getDiagList.name + '</td><td style=" text-align: right;border: 1px solid black;border-collapse: collapse;" data-th="Type">' + getDiagList.quantity + '</td><td style=" text-align: right; border: 1px solid black;border-collapse: collapse;" data-th="Fee">' + parseFloat(getDiagList.amount).toFixed(2) + '</td><td style=" text-align: right; border: 1px solid black;border-collapse: collapse;" data-th="Concession">' + getDiagList.concession + '</td><td style="text-align: right; border: 1px solid black;border-collapse: collapse;" data-th="Amount" class="fee_txt">' + parseFloat(getDiagList.fee).toFixed(2) + '</td></tr>';
  //           }
  //         }
  //         diagContent = '<div style="width: 90%; margin: 0 auto;"> <h3 class="heading">Pathologic & Radiologic</h3> <div class="row"> <table style=" border: 1px solid black;border-collapse: collapse;margin-right: 20px;width:100%;"> <thead> <tr><th style="width: 30%;border: 1px solid black;border-collapse: collapse;"> <b>Test Name</b> </th> <th style="width: 15%;border: 1px solid black;border-collapse: collapse;text-align: right;"> <b>Quantity</b> </th> <th style="width: 15%;border: 1px solid black;border-collapse: collapse;"> <b>Fee</b> </th> <th style="width: 15%;border: 1px solid black;border-collapse: collapse;"> <b>Concession (%)</b> </th> <th style="width: 15%;border: 1px solid black;border-collapse: collapse;"> <b>Amount</b> </th><tr> </thead>  <tbody>' + diagList + '</tbody> </table> </div> </div>';
  //         printContt += diagContent;
  //       }

  //       // pharma bill list 
  //       var parmaContent = "";
  //       var pharmaList = "";
  //       if (this.sendPharmacy.length != 0) {
  //         if (this.insuranceFlag != false) {
  //           for (var x = 0; x < this.sendPharmacy.length; x++) {
  //             for (var y = 0; y < this.sendPharmacy[x].billDetails.length; y++) {
  //               var getPharmaList = this.sendPharmacy[x].billDetails[y];
  //               pharmaList += '<tr><td style=" text-align: left;border: 1px solid black;border-collapse: collapse;padding:5px 5px;" data-th="Type"> ' + getPharmaList.name + '</td><td style=" text-align: left;border: 1px solid black;border-collapse: collapse;" data-th="Type">' + getPharmaList.batch_no + '</td><td style=" text-align: right;border: 1px solid black;border-collapse: collapse;" data-th="Type">' + getPharmaList.quantity + '</td><td style=" text-align: right; border: 1px solid black;border-collapse: collapse;" data-th="Concession">' + getPharmaList.concession + '</td><td style="text-align: right; border: 1px solid black;border-collapse: collapse;" data-th="Amount" class="fee_txt">' + parseFloat(getPharmaList.amount).toFixed(2) + '</td></tr>';
  //             }
  //           }
  //           parmaContent = '<div style="width: 90%; margin: 0 auto;"> <h3 class="heading">Medicine Bills </h3> <div class="row"> <table style=" border: 1px solid black;border-collapse: collapse;margin-right: 20px;width:100%;"> <thead> <tr> <th style="width: 30%;border: 1px solid black;border-collapse: collapse;"> <b>Medicine Name</b></th> <th style="width: 15%;border: 1px solid black;border-collapse: collapse;">Batch No</th> <th style="width: 15%;border: 1px solid black;border-collapse: collapse;"><b>Quantity</b> </th> <th style="width: 15%;border: 1px solid black;border-collapse: collapse;"><b>Concession (%)</b></th> <th style="width: 15%;border: 1px solid black;border-collapse: collapse;"> <b>Amount</b></th> </tr> </thead> <tbody> ' + pharmaList + '</tbody></table></div> </div>';
  //         } else {
  //           for (var x = 0; x < this.sendPharmacy.length; x++) {
  //             pharmaList += '<tr><td style="text-align: left;border: 1px solid black;border-collapse: collapse;padding:5px 5px;" data-th="Type">' + this.sendPharmacy[x].order_id + '</td><td style="text-align: right;border: 1px solid black;border-collapse: collapse;" data-th="Type" >' + parseFloat(this.sendPharmacy[x].temp_balance).toFixed(2) + '</td></tr>';
  //           }
  //           parmaContent = '<div style="width: 90%; margin: 0 auto;"><h3 class="heading">Medicine Bills </h3><div class="row"><table style="border: 1px solid black;width:100%;border-collapse: collapse;margin-right: 20px;"><thead><tr><th style="width:33%;">Bill No</th><th style="width:67%;">Amount</th></thead><tbody>' + pharmaList + '</tbody></table></div></div>';
  //         }
  //         printContt += parmaContent;
  //       }
  //       //this.final_amount this.paid_bill parseFloat(this.paid_bill).toFixed(2)
  //       var tempPaid = (parseFloat(this.totalPaid) - parseFloat(this.total_advance)).toFixed(2);
  //       printContt += '<span class="printsame" style="width: 90%; margin: 10px 0 auto;"> <table style="float: right; margin-right: 40px; margin-top: 8px; width: 75%; page-break-after: always; page-break-inside: avoid;"> <tr> <td style="width: 50%;background-color: #ffffff;"></td> <th style="text-align: left;">Bill amount (र)</th> <td style="text-align: right;width: 100px;margin-right: 10px;" data-th="Bill amount" class="fee_txt">' + this.totalBill + '</td> </tr> <tr> <td style="width: 50%;background-color: #ffffff"></td> <th style="text-align: left;">Discount (र)</th> <td style="text-align: right;width: 100px;margin-right: 10px;" data-th="" class="fee_txt"> ' + this.totalDiscount + '</td> </tr> <tr> <td style="width: 50%;background-color: #ffffff"></td> <th style="text-align: left;">Advance (र)</th> <td style="text-align: right;width: 100px;margin-right: 10px;" data-th="Advance / Paid र" class="fee_txt"> ' + this.total_advance + '</td> </tr> <tr> <td style="width: 50%;background-color: #ffffff"></td> <th style="text-align: left;"> Paid (र)</th> <td style="text-align: right;width: 100px;margin-right: 10px;" data-th="Advance / Paid र" class="fee_txt"> ' + tempPaid + '</td> </tr> <tr> <td style="width: 50%;background-color: #ffffff;"></td> <th style="text-align: left;">Balance (र)</th> <td style="text-align: right;width: 100px;margin-right: 10px;" data-th="Balance" class="fee_txt">' + this.remaing_billbal + '</td> </tr> </table> </span> </div> </div> </td> </tr> </tbody> </table> </div> </div> </div>';
  //     }
  //     printContents = printContt;
  //     // printContents = document.getElementById('bill-print-section')!.innerHTML;
  //     popupWin = window.open('', '_blank', 'top=20,left=10,height=100%,width=auto');
  //     popupWin.document.open();
  //     popupWin.document.write(`
  //     <head>
  //       <title>Bill</title>
  //       <link rel="stylesheet" media="screen" href="">
  //       <style>
  //       @page { size: auto;  margin: 0mm; }
  //       .table_class {
  //         background-color: rgb(108, 180, 248);
  //       }
  //       * {
  //         font-size: 1em !important;
  //         line-height: 1 !important;
  //       }
  //       @media print {
  //         .printsame {
  //           clear: both;
  //           page-break-inside: avoid;
  //         }
  //       }
  //       table.report-container {
  //         page-break-after:always;
  //       }
  //       thead.report-header {
  //         display:table-header-group;
  //       }
  //       tfoot.report-footer {
  //           display:table-footer-group;
  //       }
  //       .print:last-child {
  //         page-break-after: auto;
  //       } 
  //       .alignRight{
  //         text-align: right;
  //       }
  //       .col-print-1 {width:8%;  float:left;}
  //       .col-print-2 {width:16%; float:left;}
  //       .col-print-3 {width:25%; float:left;}
  //       .col-print-4 {width:33%; float:left;}
  //       .col-print-5 {width:42%; float:left;}
  //       .col-print-6 {width:50%; float:left;}
  //       .col-print-7 {width:58%; float:left;}
  //       .col-print-8 {width:66%; float:left;}
  //       .col-print-9 {width:75%; float:left;}
  //       .col-print-10{width:83%; float:left;}
  //       .col-print-11{width:92%; float:left;}
  //       .col-print-12{width:100%; float:left;}
  //       </style>
  //     </head>
  //         <body onload="window.print();window.onfocus=function(){ window.close();}">${printContents}</body>
  //       </html>`
  //     );
  //     popupWin.document.close();
  //   }

  // }

  printBill(){
    let printContents, popupWin;
    if (this.print_template != undefined && this.print_template == "banner") {
      printContents = this.printbanner.nativeElement.innerHTML; //document.getElementById('print-section').innerHTML;

    } else if (this.print_template != undefined && this.print_template == "logowithname") {
      printContents = this.printlogowithname.nativeElement.innerHTML; //document.getElementById('print-section').innerHTML;

    } else {
      printContents = this.printnoheader.nativeElement.innerHTML;
    }

    popupWin = window.open('', '_blank', 'top=20,left=10,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
    <head>
      <title>Consolidated bill</title>
      <link rel="stylesheet" media="screen" href="">
      <style>
      @page { size: auto;  margin: 0mm; }
      .table_class {
        background-color: rgb(108, 180, 248);
      }
      p{
        margin:0;
      }
      
      </style>
    </head>
        <body onload="window.print();window.onfocus=function(){ window.close();}">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  Bill_save() {
    var flag = true;

    if (this.sendDoctor.length == 0 && this.sendPharmacy.length == 0 && this.sendDiagnosis.length == 0) {
      this.toastr.error("Select atleast one bill type");
      flag = false;
    } else if (this.Advance_bill == "0.00" && this.paid_bill == "0.00") {
      this.toastr.error("Please fill paid amount");
      flag = false;
    }

    var advance;
    if (parseFloat(this.final_amount) == (parseFloat(this.paid_bill) + parseFloat(this.Advance_bill))) {
      advance = "0.00";
    } else if (parseFloat(this.final_amount) < parseFloat(this.Advance_bill)) {
      advance = ((parseFloat(this.Advance_bill) - parseFloat(this.final_amount))).toFixed(2);
    } else {
      advance = "0.00";
    }

    if (flag == true) {
      console.log("Doctor bills " + JSON.stringify(this.sendDoctor))
      console.log("PHARMA BILLS " + JSON.stringify(this.sendPharmacy))
      console.log("DIAGNOSIS BILLS " + JSON.stringify(this.sendDiagnosis))

      var sendData = {
        client_reg_id: this.client_id,
        advance_balance: advance,
        hptl_clinic_id: this.hptl_clinic_id,
        appointment_id: this.app_id,
        pharma: this.sendPharmacy,
        diagnosis: this.sendDiagnosis,
        doctor: this.sendDoctor,
      }
      this.saveFlag = false;
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      this.http.post(ipaddress.getIp.toString() + 'bill/ucb/', sendData,

        { headers: headers })
        .subscribe(
          response => {
            var obj = response.json();

            if (obj["result"] != null) {
              if (obj["key"] == "1") {
                this.toastr.success("Success");
              } else {
                this.toastr.error("Error");
                this.saveFlag = true;
              }
            }
          },
          error => {
            this.saveFlag = true;
            // this.toastr.error(Message_data.getNetworkMessage());
          }
        )

    }
  }

  getPatientList(patientList) {
    this.patientList = [];
    if (patientList.target.value.toString() != null && patientList.target.value.toString().length > 2) {
      var headers = new Headers();
      var name = encrypt_decript.Encript(patientList.target.value.toString())
      headers.append('Content-Type', 'application/json');
      this.http.post('bill/inpa', JSON.stringify({
        name: patientList.target.value.toString(),
      }), { headers: headers }).subscribe(
        data => {
          // if (data.json().locations != null && data.json().locations.length != 0) {

          // }
        },
        error => {
          this.toastr.error("Unable to get doctor details");
        }
      )
    } else {
      this.patientList = [];
    }
  }
}
